import { motion } from "framer-motion";
import { styled } from "styled-components";

const BackAction = styled.div`
  height: 24px;
  & > svg {
    transform: rotate(180deg);
  }
`;

const Container = styled.header`
  width: 100%;

  display: grid;
  grid-template-columns: 24px 1fr 24px;
  align-items: center;
  max-height: 24px;
  color: ${({ theme }) => theme.colors.black};

  & > svg {
    cursor: pointer;
    &:active {
      transform: scale(1.2);
      transition: ${({ theme }) => theme.transitions.easeAll};
    }
  }

  & > div {
    position: relative;
    align-items: center;
    justify-content: center;
  }

  & > .back-action {
    grid-column: 1 / 2;
  }

  & > .addressBlock {
    grid-column: 2 / 3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & > .user-icon {
    grid-column: 3 / 4;
  }
`;

const Address = styled.div`
  cursor: pointer;

  display: flex;
  gap: 0.5rem;
  align-items: center;

  font-family: ${({ theme }) => theme.fonts.manrope};
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.25rem;

  & > svg {
    transform: rotate(90deg);
  }
`;

const Addresses = styled(motion.div)`
  z-index: 1000;
  position: absolute;
  left: 50%;
  top: 36px;

  border-radius: 16px;
  box-shadow: rgba(44, 48, 52, 0.12) 0px 12px 20px 0px;
  border: 1px solid rgb(199, 186, 184);
  background: rgb(243, 235, 234);
  padding: 8px 0px;
  width: 280px;

  display: flex;
  flex-direction: column;

  & > div {
    width: 100%;

    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 8px 14px;

    & > span {
      font-family: ${({ theme }) => theme.fonts.manrope};
      font-size: 0.8125rem;
      line-height: 1.25rem;

      &:first-of-type {
        color: #2c3034;
        font-weight: 700;
      }

      &:last-of-type {
        flex: 1;
        color: #736963;
        text-align: right;
        font-weight: 600;
      }
    }

    & > svg {
      &:first-of-type {
        width: 1.375rem;
        height: 1.375rem;
      }

      &:last-of-type {
        cursor: pointer;
        width: 1rem;
        height: 1rem;
      }
    }
  }
`;

export default {
  BackAction,
  Container,
  Address,
  Addresses,
};
